'use client';

import * as React from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';

import { cn } from 'src/lib/utils';

function Switch({ className, ...props }) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        'peer inline-flex h-8 w-14 shrink-0 cursor-pointer items-center rounded-full p-1 transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
        'data-[state=unchecked]:bg-gray-300',
        className
      )}
      style={{
        border: 'none',
        outline: 'none',
        backgroundColor: props.checked ? '#3766a8' : undefined
      }}
      {...props}>
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          'pointer-events-none block h-6 w-6 rounded-full bg-white shadow-md ring-0 transition-transform duration-200',
          'data-[state=checked]:translate-x-6 data-[state=unchecked]:translate-x-0'
        )}
        style={{ border: 'none' }}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
